import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "SuitHeart.svg",
  "use": "SuitHeart.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"SuitHeart.svg\"><path d=\"M22.01,12.0253a11.0488,11.0488,0,0,1,10,6.3748,11.0121,11.0121,0,0,1,21,4.6249c0,10.8464-14.7695,20.7979-19.5289,28.2131a1.77,1.77,0,0,1-2.9425,0C25.78,43.8229,11.0106,33.8714,11.0106,23.025A11.0017,11.0017,0,0,1,22.01,12.0253Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol